<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import mxdj from "./mxdj/index.vue";
import seeywkm from "./seeywkm/index.vue";
import uploadFile from '../../../common/uploadFile/index.vue'
import {
  wpsr_initInfo_api,
  wpsr_infoPage_api,
  wpsr_dataOriginInfoPage_api,
  wpsr_updateLy_api,
  wpsr_updateData_api,
  wpsr_clearNowTax_api, wpsr_saveFill_api, wpsr_uploadFile_api
} from "@/api/wpsr";
import config from "../../../../../configHttp";

export default {
  name: "wpsr",
  components: {
    mxdj,
    seeywkm,
    uploadFile
  },
  data: function () {
    return {
      tablekey: 0,
      overlength: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      lypagination: getdata().lypagination,
      tableData: [{}],
      shaidiag: false,
      searchdiag: false,
      sjlydiag: false,
      headlyData: getdata().headlyData,
      tablelyData: [],
      showmxdj: false,
      ywdiag: false,
      yuzl1:"",
      yuzl2:"",
      yuzl3:"",
      ishztx:false,
      hztxItems:{}, //汇总填写，
      mxdjInitData: getdata().mxdjInitData,
      filediag:false,
      upformdata: {},
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    forback() {
      this.showmxdj = false;
      this.getWpsrInfo();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
    },
    currentChange(e) {
      this.pagination.pageNum = e;
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getWpsrInfo();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    closediagywdiag() {
      this.ywdiag = false;
    },
    //数据来源配置
    sjlypz(){
      this.getDataOriginInfo();
    },
    //初始化数据
    init() {
      wpsr_initInfo_api({}).then((res) => {
        if (res.data.code != 1) {
          this.$message.error(res.data.msg);
        } else {
          this.suosq = this.$getdefultMonth()
          this.searchdata.suosq = this.$getdefultMonth()
          this.getWpsrInfo();
        }
      });
    },
    //页面多条件查询
    getWpsrInfo() {
      //查询数据
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "id";
      params.order = "asc";
      wpsr_infoPage_api(params).then((res) => {
        if (res.data.code == 1) {
          this.pagination.total = res.data.data.total;
          this.pagination.paginationkey++;
          this.tableData = res.data.data.records;
          this.jinyongpd();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //数据处理
    jinyongpd() {
      this.yuzl1 = "";
      this.yuzl2 = "";
      this.yuzl3 = "";
      this.tableData.forEach((res) => {
        res.sfyshenbao = res.suosqbz == "1" ? true : false; //是否是当前申报期
        res.sfupdate = false; //是否编辑
        //预征率不会超过三种，所以直接取有值的
        if(res.jianyYuzl1Shuil){
          this.yuzl1 = parseInt(parseFloat(res.jianyYuzl1Shuil) * 1000) / 10;
        }
        if(res.jianyYuzl2Shuil){
          this.yuzl2 = parseInt(parseFloat(res.jianyYuzl2Shuil) * 1000) / 10;
        }
        if(res.jianyYuzl3Shuil){
          this.yuzl3 = parseInt(parseFloat(res.jianyYuzl3Shuil) * 1000) /10;
        }
      });
    },
    //获取来源配置
    getDataOriginInfo() {
      //查询数据
      let params = {};
      params.page = this.lypagination.pageNum;
      params.size = this.lypagination.pageSize;
      params.suosq = this.searchdata.suosq;
      wpsr_dataOriginInfoPage_api(params).then((res) => {
        if (res.data.code != 1) {
          this.$message.error(res.data.msg);
        } else {
          this.lypagination.total = res.data.data.total;
          this.lypagination.paginationkey++;
          this.tablelyData = res.data.data.records;
          this.tablelyData.forEach((item) => {
            item.radiolist = this.$WpsrShujlyMapping;
          });
        }
        this.sjlydiag = true;
      });
    },
    //置为手工开票/置为科目余额表
    changeBatchShujlyButton(val) {
      let selectVal = this.$refs.tableboxly.getSelectionval();
      if (selectVal.length < 1) {
        this.$message.info("请选择数据再进行操作");
        return;
      }
      selectVal.forEach((item) => {
        item.laiy = val;
      });
    },
    //配置来源页面返回
    closelydiag() {
      this.sjlydiag = false;
    },
    //数据来源配置保存按钮
    saveDataOriginConfigButton() {
      this.$showConfirm({
        message:
            "切换数据来源，会清空当前纳税人下未申报成功的税款所属期已有数据（已申报成功的数据不受影响），是否继续？",
      }).then((res) => {
        if (res == "confirm") {
          this.saveDataOriginConfig();
        }
      });
    },
    //保存数据来源配置
    saveDataOriginConfig() {
      let param = this.tablelyData;
      wpsr_updateLy_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
        this.getWpsrInfo();
        this.sjlydiag = false;
      });
    },
    //批量更新取数 到时候可能做异步处理，所以和单个更新取数区分开来
    updateBatchData() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      if (selectVal.length == 0) {
        this.$message.info("请选中数据再进行更新取数操作");
        return;
      }
      let suosq = selectVal[0].suosq;
      let ids = new Array(selectVal.length);
      try {
        selectVal.forEach((v, k) => {
          if (v.shujly != 1) {
            throw new Error("只有数据来源为‘科目余额表’才能进行更新取数操作");
          }
          if (suosq != v.suosq) {
            throw new Error("只有相同所属期期才能进行批量更新取数");
          }
          ids[k] = v.id;
        });
      } catch (e) {
        this.$message.info(e.message);
        return;
      }
      this.updateWupsrData(ids, suosq);
    },
    //单条数据更新取数
    updateSingleData(row) {
      if (!row.sfyshenbao) {
        return;
      }
      if (row.shujly != 1) {
        this.$message.info("只有数据来源为‘科目余额表’才能进行更新取数操作");
        return;
      }
      let ids = [row.id];
      this.updateWupsrData(ids, row.suosq);
    },
    //更新取数
    updateWupsrData(e, ssq) {
      let param = {
        ids: e,
        suosq: ssq,
      };
      wpsr_updateData_api(param).then((res) => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.getWpsrInfo();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //清空数据
    clearData(row) {
      if (!row.sfyshenbao) {
        return;
      }
      this.$showConfirm({
        message: "清空数据后当前税款所属期间内的所有数据将清除，是否确认操作？",
      }).then((res) => {
        if (res == "confirm") {
          this.clearNowTax(row);
        }
      });
    },
    clearNowTax(e) {
      let param = {
        id: e.id,
        suosq: e.suosq,
      };
      wpsr_clearNowTax_api(param).then((res) => {
        if (res.data.code == 1) {
           this.$message.success(res.data.msg);
           this.getWpsrInfo();
        } else {
            this.$message.error(res.data.msg);
        }
      });
    },
    //打开汇总填写
    openhztx(row,index){
      if (!row.sfyshenbao) {
        return;
      }
	 
	 let arr = ['yibHuowxl13Xse','yibHuowxl13Ynse','yibFuwbdcwxzc13Xse','yibFuwbdcwxzc13Ynse',
	 'yibHuowxl9Xse','yibHuowxl9Ynse','yibFuwbdcwxzc9Xse','yibFuwbdcwxzc9Ynse','yibShuil6Xse',
	 'yibShuil6Ynse','jianyZhengsl6Xse','jianyZhengsl6Ynse','jianyHuowx5Xse','jianyHuowx5Ynse',
	 'jianyFuwbdcwxzc5Xse','jianyFuwbdcwxzc5Ynse','jianyZhengsl4Xse','jianyZhengsl4Ynse','jianyHuowx3Xse',
	 'jianyHuowx3Ynse','jianyFuwbdcwxzc3Xse','jianyFuwbdcwxzc3Ynse','jianyYuzl1Xse','jianyYuzl1Ynse',
	 'jianyYuzl2Xse','jianyYuzl2Ynse','jianyYuzl3Xse','jianyYuzl3Ynse']
	 for(let indedx = 0 ; indedx < arr.length ; indedx++){
	 	if(this.tableData[index][arr[indedx]]==''||this.tableData[index][arr[indedx]]==null){
	 		this.tableData[index][arr[indedx]] = 0
	 	}
	 }
      this.hztxItems = JSON.parse(JSON.stringify(row));
      row.sfupdate = true;
      this.tableData = JSON.parse(JSON.stringify(this.tableData));
      this.ishztx = true;
    },
    //保存汇总填写
    saveHztx(e){
		let arr = ['yibHuowxl13Xse','yibHuowxl13Ynse','yibFuwbdcwxzc13Xse','yibFuwbdcwxzc13Ynse',
		'yibHuowxl9Xse','yibHuowxl9Ynse','yibFuwbdcwxzc9Xse','yibFuwbdcwxzc9Ynse','yibShuil6Xse',
		'yibShuil6Ynse','jianyZhengsl6Xse','jianyZhengsl6Ynse','jianyHuowx5Xse','jianyHuowx5Ynse',
		'jianyFuwbdcwxzc5Xse','jianyFuwbdcwxzc5Ynse','jianyZhengsl4Xse','jianyZhengsl4Ynse','jianyHuowx3Xse',
		'jianyHuowx3Ynse','jianyFuwbdcwxzc3Xse','jianyFuwbdcwxzc3Ynse','jianyYuzl1Xse','jianyYuzl1Ynse',
		'jianyYuzl2Xse','jianyYuzl2Ynse','jianyYuzl3Xse','jianyYuzl3Ynse']
		for(let indedx = 0 ; indedx < arr.length ; indedx++){
			if(this.hztxItems[arr[indedx]]==''||this.hztxItems[arr[indedx]]==null){
				this.hztxItems[arr[indedx]] = 0
			}
		}
      //预征率税率赋值
      if(this.hztxItems.jianyYuzl1Xse && this.hztxItems.jianyYuzl1Ynse){
        this.hztxItems.jianyYuzl1Shuil = parseFloat(this.yuzl1) / 100.0;
      }
      if(this.hztxItems.jianyYuzl2Xse && this.hztxItems.jianyYuzl2Ynse){
        this.hztxItems.jianyYuzl2Shuil = parseFloat(this.yuzl2) / 100.0;
      }
      if(this.hztxItems.jianyYuzl3Xse && this.hztxItems.jianyYuzl3Ynse){
        this.hztxItems.jianyYuzl3Shuil = parseFloat(this.yuzl3) / 100.0;
      }
      wpsr_saveFill_api(this.hztxItems).then(res =>{
          if(res.data.code == 1){
              this.$message.success(res.data.msg)
              e.sfupdate = false;
              this.ishztx = false;
              this.getWpsrInfo();
          } else {
            this.$message.error(res.data.msg)
          }
      })
    },
    //取消汇总填写
    cancelHztx(e){
      this.hztxItems = {};
      //重新给预征率赋值
      this.jinyongpd();
      e.sfupdate = false;
      this.ishztx = false;
    },
    //预征率计算应纳税额
    computeYnse(){
      if(this.yuzl1 && this.yuzl1 != '' && this.hztxItems.jianyYuzl1Xse && this.hztxItems.jianyYuzl1Xse != ''){
        let shuil = parseFloat(parseFloat(this.yuzl1) / 100);
        let xse = parseFloat(this.hztxItems.jianyYuzl1Xse);
        let ynse =  (xse * shuil).toFixed(2);
        this.hztxItems.jianyYuzl1Ynse = ynse;
      }
      if(this.yuzl2 && this.yuzl2 != '' && this.hztxItems.jianyYuzl2Xse && this.hztxItems.jianyYuzl2Xse != ''){
        let shuil = parseFloat(parseFloat(this.yuzl2) / 100);
        let xse = parseFloat(this.hztxItems.jianyYuzl2Xse);
        let ynse =  (xse * shuil).toFixed(2);
        this.hztxItems.jianyYuzl2Ynse = ynse;
      }
      if(this.yuzl3 && this.yuzl3 != '' && this.hztxItems.jianyYuzl3Xse && this.hztxItems.jianyYuzl3Xse != ''){
        let shuil = parseFloat(parseFloat(this.yuzl3) / 100);
        let xse = parseFloat(this.hztxItems.jianyYuzl3Xse);
        let ynse =  (xse * shuil).toFixed(2);
        this.hztxItems.jianyYuzl3Ynse = ynse;
      }
    },
    computeYnse1(sl , o , v1, v2){
      let xseVal = o[v1];
      let ynse = '';
      if(xseVal) {
        let shuil = parseFloat(sl);
        let xse = parseFloat(o[v1]);
        ynse = (xse * shuil).toFixed(2);
      }
      o[v2] = ynse;
      this.hztxItems = JSON.parse(JSON.stringify(o));
    },
    //打开明细登记
    openmxdj(row){
      if (!row.sfyshenbao) {
        return;
      }
      this.mxdjInitData.nsrsbh = row.nsrsbh;
      this.mxdjInitData.suosq = row.suosq;
      this.mxdjInitData.wpsrId = row.id;
      this.showmxdj = true;
    },
    //导出列表
    downloadList() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let params = {
        pageShowListPojo: {},
      };
      if (selectVal.length < 1) {
        params.pageShowListPojo = JSON.parse(JSON.stringify(this.searchdata));
      } else {
        let _ids = selectVal.map((item) => item.id);
        params.ids = _ids;
      }
      params.json = getdata().tableJson;
      this.fileDownload(params);
    },
    fileDownload(val) {
      let params = {
        downUrl: config.baseURL + "/wpsr/list/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          fileName: "无票收入数据"+ this.$timestampToStr(new Date(), "yyyyMMdd"),
          failUrl:this.$winURl
        },
        params: val,
      };
      this.$downloadcommon(params);
    },
    showFileUpload(){
      this.upformdata = {
        upfilename: "",
        upfile: "",
        filestate: "",
        filetype: "",
        filesize: "",
      };
      this.filediag = true;
    },
    forupload() {
      if (this.$emptyandnull(this.upformdata.upfile)) {
        this.$message.error("请选择要上传的文件");
        return false;
      }
      let formData = {
        importType: '0',
        file: this.upformdata.upfile,
      };
      wpsr_uploadFile_api(formData).then((res) => {
        if ((res.data.code == 1)) {
          if (res.data.data.errorCount > 0) {
            this.fordowloaderr(this.upformdata.filetype , res.data.data.batchNo);
          } else {
            this.$message.success("上传成功");
          }
          this.getWpsrInfo();
          this.filediag = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    fordowloaderr(filetype, batchNo) {
      let params = {
        downUrl: config.baseURL + "/upload-history/downloadErrorFile",
        typeObj: {
          toForm: true,
          fileType:filetype,
          failUrl:this.$winURl
        },
        params: {
          batchNo: batchNo,
        },
      };
      this.$downloadcommon(params);
    },
    //下载标准模板
    fordownloadmb() {
      //简单下载，交给浏览器去做处理
      	let params = {
        downUrl: config.baseURL + "/wpsr/dowloadTemplate",
        typeObj: {
						toForm: true,
						fileType: "xlsx",
            failUrl:this.$winURl
					},
					params:{},
      	};
      	this.$downloadcommon(params);
    },
    getuploadparams(e) {
      //获取上传文件流
      this.upformdata = e;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
